import MapCache from "./_MapCache.js";
import setCacheAdd from "./_setCacheAdd.js";
import setCacheHas from "./_setCacheHas.js";
function SetCache(values) {
  var index = -1, length = values == null ? 0 : values.length;
  for (this.__data__ = new MapCache(); ++index < length; )
    this.add(values[index]);
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
export {
  SetCache as default
};
//# sourceMappingURL=_SetCache.js.map
